import { Trans } from '@lingui/react/macro';

import { WrappedInfoCircle } from '@/components/base/notifications/notifications';

export default function TwoStepsToQualifyCard() {
  return (
    <div className="flex flex-row gap-4 rounded-xl bg-brand-primary p-6 text-sm">
      <div className="hidden lg:block">
        <WrappedInfoCircle color="brand-primary" ringSize="sm" />
      </div>
      <div className="flex flex-col items-start">
        <h3 className="mb-2 flex flex-row gap-4 font-semibold text-primary">
          <span className="lg:hidden">
            <WrappedInfoCircle color="brand-primary" ringSize="sm" />
          </span>
          <Trans>Two steps to Qualify</Trans>
        </h3>
        <p className="text-secondary">
          <Trans>
            To join this paid study, you need to pass two steps. If you pass the
            first screener, you'll be invited to complete the second on our
            partner's platform. Passing both grants access to the paid study.
          </Trans>
        </p>
      </div>
    </div>
  );
}
